(function () {
  if (window.VimaSizeFinder && typeof window.VimaSizeFinder.sync === 'function') {
    window.VimaSizeFinder.sync();
    return;
  }

  var pending = null;

  function parseSize(text) {
    var range = text && text.match(/([^()]+?)\s*\(([\d,.]+)\s*[–-]\s*([\d,.]+)\s*cm\)/i);
    if (range) {
      return {
        size: range[1].trim(),
        mode: 'range',
        min: parseFloat(range[2].replace(',', '.')),
        max: parseFloat(range[3].replace(',', '.'))
      };
    }

    var limit = text && text.match(/([^()]+?)\s*\(\s*<\s*([\d,.]+)\s*cm\)/i);
    if (limit) {
      return {
        size: limit[1].trim(),
        mode: 'limit',
        max: parseFloat(limit[2].replace(',', '.'))
      };
    }
    return null;
  }

  function labelFor(input) {
    return input && input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL'
      ? input.nextElementSibling
      : null;
  }

  function activePicker() {
    return document.querySelector('variant-selects.vima-size-picker');
  }

  function showRecommendation() {
    if (!pending) return;
    var picker = activePicker();
    if (!picker) return;

    var finder = picker.querySelector('.vima-size-finder');
    var result = finder && finder.querySelector('.vima-size-finder__result');
    var inputs = picker.querySelectorAll('.vima-size-track input[type="radio"]');
    var target = null;
    var i;

    if (finder) finder.open = true;
    if (result) result.textContent = pending.message;

    for (i = 0; i < inputs.length; i += 1) {
      var label = labelFor(inputs[i]);
      var data = parseSize(label && label.textContent);
      if (data && data.size === pending.size) {
        target = inputs[i];
        break;
      }
    }
    if (!target) return;

    var targetLabel = labelFor(target);
    var track = target.parentElement;
    if (!targetLabel || !track || !track.classList.contains('vima-size-track')) return;

    var oldRecommended = track.querySelectorAll('.vima-size-recommended');
    for (i = 0; i < oldRecommended.length; i += 1) {
      oldRecommended[i].classList.remove('vima-size-recommended');
    }
    targetLabel.classList.add('vima-size-recommended');

    var trackRect = track.getBoundingClientRect();
    var labelRect = targetLabel.getBoundingClientRect();
    var desired = track.scrollLeft + (labelRect.left - trackRect.left)
      - ((track.clientWidth - targetLabel.offsetWidth) / 2);
    track.scrollLeft = Math.max(0, desired);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target;
    if (!input || !input.closest || !input.closest('.vima-size-finder')) return;
    event.preventDefault();
    var finder = input.closest('.vima-size-finder');
    var button = finder && finder.querySelector('[data-vima-size-action]');
    if (button) button.click();
  });

  document.addEventListener('focusout', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('.vima-size-finder input')) return;

    var next = event.relatedTarget;
    if (next && next.closest && next.closest('[data-vima-size-action]')) return;

    var finder = input.closest('.vima-size-finder');
    var button = finder && finder.querySelector('[data-vima-size-action]');
    if (!button || !String(input.value).trim()) return;

    window.setTimeout(function () {
      if (!input.isConnected) return;
      button.click();
    }, 0);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-vima-size-action]');
    if (!button) return;
    event.preventDefault();

    var finder = button.closest('.vima-size-finder');
    var picker = button.closest('variant-selects');
    var fieldset = finder && finder.nextElementSibling;
    var result = finder && finder.querySelector('.vima-size-finder__result');
    var inputField = finder && finder.querySelector('input');
    if (!finder || !picker || !fieldset || !result || !inputField) return;

    var value = parseFloat(String(inputField.value).replace(',', '.'));
    if (isNaN(value)) {
      result.textContent = 'Indiquez la longueur du pied en cm.';
      finder.open = true;
      return;
    }

    var inputs = fieldset.querySelectorAll('.vima-size-track input[type="radio"]');
    var candidates = [];
    var i;
    for (i = 0; i < inputs.length; i += 1) {
      var label = labelFor(inputs[i]);
      var data = parseSize(label && label.textContent);
      if (data && !inputs[i].disabled && !inputs[i].classList.contains('disabled')) candidates.push({ input: inputs[i], data: data });
    }

    var matches = [];
    var limitChoice = null;
    for (i = 0; i < candidates.length; i += 1) {
      var item = candidates[i];
      if (item.data.mode === 'range' && value >= item.data.min && value <= item.data.max) {
        matches.push(item);
      } else if (item.data.mode === 'limit' && value < item.data.max && !limitChoice) {
        limitChoice = item;
      }
    }
    if (!matches.length && limitChoice) matches.push(limitChoice);

    if (!matches.length) {
      result.textContent = 'Aucune pointure disponible ne correspond à cette mesure.';
      finder.open = true;
      return;
    }

    var selected = matches[matches.length - 1];
    var sizes = [];
    for (i = 0; i < matches.length; i += 1) sizes.push(matches[i].data.size);

    var message = matches.length > 1
      ? 'Deux pointures conviennent : ' + sizes.join(' et ') + '. D’après la mesure indiquée, nous vous conseillons ' + selected.data.size + '.'
      : 'Pointure conseillée : ' + selected.data.size;

    pending = { size: selected.data.size, message: message };
    result.textContent = message;
    finder.open = true;

    selected.input.checked = true;
    selected.input.dispatchEvent(new Event('change', { bubbles: true }));

    window.setTimeout(showRecommendation, 30);
    window.setTimeout(showRecommendation, 200);
    window.setTimeout(function () {
      showRecommendation();
      pending = null;
    }, 600);
  });

  function morphologyLabel(values, kind) {
    if (!Array.isArray(values) || !values.length) return '';
    var normalized = values.map(function (value) { return String(value).toLowerCase(); });

    if (kind === 'width') {
      if (normalized.includes('fine') && normalized.includes('moyenne') && normalized.includes('large')) return 'Largeur du pied : fine à large';
      if (normalized.includes('fine') && normalized.includes('moyenne')) return 'Largeur du pied : fine à moyenne';
      if (normalized.includes('moyenne') && normalized.includes('large')) return 'Largeur du pied : moyenne à large';
      if (normalized.includes('fine')) return 'Largeur du pied : fine';
      if (normalized.includes('large')) return 'Largeur du pied : large';
      if (normalized.includes('moyenne')) return 'Largeur du pied : moyenne';
    } else {
      if (normalized.includes('faible') && normalized.includes('moyenne') && normalized.includes('forte')) return 'Épaisseur du pied : faible à forte';
      if (normalized.includes('faible') && normalized.includes('moyenne')) return 'Épaisseur du pied : faible à moyenne';
      if (normalized.includes('moyenne') && normalized.includes('forte')) return 'Épaisseur du pied : moyenne à forte';
      if (normalized.includes('faible')) return 'Épaisseur du pied : faible';
      if (normalized.includes('forte')) return 'Épaisseur du pied : forte';
      if (normalized.includes('moyenne')) return 'Épaisseur du pied : moyenne';
    }

    return '';
  }

  function updateMorphology(picker) {
    if (!picker) return;

    var panel = picker.querySelector('[data-vima-product-profile]');
    var dataNode = picker.querySelector('[data-vima-morphology-map]');
    if (!panel || !dataNode) return;

    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var selected = new Map();
    picker.querySelectorAll('[data-option-name]').forEach(function (node) {
      var name = node.dataset.optionName;
      if (!name) return;
      if (node.matches('input[type="radio"]') && node.checked) selected.set(name, node.value);
      if (node.matches('option') && node.selected) selected.set(name, node.value);
    });

    var optionNames = Array.isArray(data.optionNames) ? data.optionNames : [];
    var variants = Array.isArray(data.variants) ? data.variants : [];
    var variant = variants.find(function (candidate) {
      return optionNames.every(function (name, index) {
        return !selected.has(name) || String(candidate.options && candidate.options[index]) === String(selected.get(name));
      });
    });

    var widthValues = variant && Array.isArray(variant.width) && variant.width.length ? variant.width : data.productWidth;
    var thicknessValues = variant && Array.isArray(variant.thickness) && variant.thickness.length ? variant.thickness : data.productThickness;
    var width = morphologyLabel(widthValues, 'width');
    var thickness = morphologyLabel(thicknessValues, 'thickness');
    var widthEl = panel.querySelector('[data-vima-profile-width]');
    var thicknessEl = panel.querySelector('[data-vima-profile-thickness]');

    if (widthEl) {
      if (widthEl.textContent !== width) widthEl.textContent = width;
      if (widthEl.hidden !== !width) widthEl.hidden = !width;
    }
    if (thicknessEl) {
      if (thicknessEl.textContent !== thickness) thicknessEl.textContent = thickness;
      if (thicknessEl.hidden !== !thickness) thicknessEl.hidden = !thickness;
    }

    var shouldHidePanel = !width && !thickness;
    if (panel.hidden !== shouldHidePanel) panel.hidden = shouldHidePanel;
  }

  function syncMorphologyPickers() {
    document.querySelectorAll('variant-selects [data-vima-product-profile]').forEach(function (panel) {
      updateMorphology(panel.closest('variant-selects'));
    });
  }

  function markSizeConfirmed(input) {
    if (!input || !input.closest) return;
    var picker = input.closest('variant-selects.vima-size-picker');
    if (!picker || !input.closest('.vima-size-track')) return;
    picker.classList.add('vima-size-confirmed');
    var productInfo = picker.closest('product-info');
    if (productInfo) productInfo.setAttribute('data-vima-size-confirmed', 'true');
  }

  function syncConfirmedPickers() {
    document.querySelectorAll('product-info[data-vima-size-confirmed="true"] variant-selects.vima-size-picker')
      .forEach(function (picker) {
        picker.classList.add('vima-size-confirmed');
      });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;

    var picker = target.closest && target.closest('variant-selects');
    if (picker) window.requestAnimationFrame(function () { updateMorphology(picker); });

    if (target.matches('.vima-size-track input[type="radio"]')) {
      markSizeConfirmed(target);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.requestAnimationFrame(function () {
        syncConfirmedPickers();
        syncMorphologyPickers();
        if (pending) showRecommendation();
      });
    });
  }

  window.VimaSizeFinder = {
    sync: function () {
      syncConfirmedPickers();
      syncMorphologyPickers();
      if (pending) showRecommendation();
    }
  };

  window.VimaSizeFinder.sync();
}());